<template>
  <div :class="`row row-question ${divStyle}`">
    <div class="block block--gray">
      <div class="container px-4 question">
        <h3>{{ translate.questionTitle }}</h3>
        <div class="txt-html" v-html="perfilQuestion" :style="isMobile ? 'column-count: 1' : 'column-count: 2'"></div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { isMobile } from 'views/shared/utils/mobile'

export default {
  name: 'PerfilModel',
  props: ['model', 'translate', 'divStyle'],
  created() {
    if (this.model) {
      this.getModel()
    }
  },
  watch: {
    'model': function () {
      this.getModel()
    }
  },
  data() {
    return {
      name: '',
      description: '',
      text: '',
      imgPerfil: '',
      perfilQuestion: '',
      isMobile: isMobile(),
    }
  },
  methods: {
    getModel() {
      this.name = this.model.nameModel
      this.description = this.model.descriptionModel
      this.text = this.model.text
      this.imgPerfil = this.model.imgPerfil
      this.perfilQuestion = this.model.profileQuestion
    }
  }
}
</script>
<style scoped lang="css">
h3 h1 p {
  font-family: 'Exo-2';
}

h3 {
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.text {
  color: #5b5858;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;  
  max-width: 500px;  
}

.questio div {
  opacity: 0.7;
  color: #444444;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}
.model-info {
  padding-left: 110px;
}

.row .buttons-video>.col,
.row>[class*='col-'] {
  padding-right: 5px;
  padding-left: 5px;
}

.img-perfil-model {
  width: 100%;
  right: -5px;
}

.txt-html {
  color: #5b5858;
  font-family: 'Roboto-Regular';
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;  
}

.div-profile-hidden {
  top: -50px;
  height: 300px;
  overflow: hidden;
  -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)));  
}

.div-profile-show {
  top: -50px;  
  height: auto;
  animation-name: profile-fadein;
  animation-duration: 2s;
}

@keyframes profile-fadein {
  0% { opacity: 0.4;  }
  100% { opacity: 1;  }
}  

@media screen and (max-width: 992px) {
  .title {
    display: none;
  }

  .block {
    padding: 0px;
    margin-top: 0px;
  }

  .question {
    padding-right: 50px !important;
  }

  .block--gray {
    padding-top: 50px;
  }

  .model-data {
    border-radius: 30px;
    top: -80px;
    z-index: 1;
    background-color: white;
    right: -15px;    
    padding-left: 40px !important;
  }

  .model-info {
    padding-left: 10px;
  }  
  .img-perfil-model, .row-question {
    right: -15px;
  }  

}
</style>
